import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Colors from '~/utils/colors';

const Title = styled.p`
  font-size: 20px;
  font-weight: 700;
  @media (max-width: 700px) {
    font-size: 15px;
  }
`;

const SearchBoxContainer = styled.div`
  text-align: left;
`;

const SearchboxForm = styled.form`
  display: flex;
  padding-top: 6px;
  position: relative;
  padding: 0;
  @media (max-width: 700px) {
    padding: 0;
    width: 100%;
  }
`;

const ActionContainer = styled.div`
  box-sizing: border-box !important;
  border-radius: 0 6px 6px 0;
  width: 30px;
  min-width: 30px;
  height: 40px;
  border-top: 1px solid ${Colors.borderGray};
  border-right: 1px solid ${Colors.borderGray};
  border-bottom: 1px solid ${Colors.borderGray};
  border-left: none;
  overflow: hidden;
  margin: 0;
  @media (max-width: 700px) {
    height: 35px;
  }
`;

const SearchInput = styled.input`
  box-sizing: border-box !important;
  flex: 1;
  border-radius: 6px 0 0 6px;
  font-size: 15px;
  height: 40px;
  border-top: 1px solid ${Colors.borderGray};
  border-bottom: 1px solid ${Colors.borderGray};
  border-left: 1px solid ${Colors.borderGray};
  border-right: none;
  padding: 0 8px;
  outline: none;
  color: ${Colors.gray};
  max-width: 220px;
  margin: 0;
  @media (max-width: 700px) {
    height: 35px;
    font-size: 13px;
    max-width: initial;
  }
`;

const SearchButton = styled.button`
  box-sizing: border-box !important;
  border: none;
  width: 100%;
  height: 100%;
  background: #fff url("/static/images/Nav/search-grey.png") 50% 50% no-repeat;
  background-size: 13px;
`;

const ResetButton = styled.button`
  box-sizing: border-box !important;
  border: none;
  width: 100%;
  height: 100%;
  background: #fff url("/static/images/Nav/close-grey.png") 50% 50% no-repeat;
  background-size: 13px;
  ${props => props.isHide && 'display: none;'}
`;
export default class SearchBox extends Component {
  static propTypes = {
    logClearFullTextSearch: PropTypes.func,
    logSubmitFullTextSearch: PropTypes.func,
  }

  state = {
    text: '',
  }

  onChange = (e) => {
    this.setState({ text: e.target.value });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.logSubmitFullTextSearch(this.refs.search.value)
      .then(() => {
        window.location.href = `/search/Any?text=${encodeURIComponent(this.refs.search.value)}`;
      });
  }

  clearInput = () => {
    this.refs.search.value = '';
    this.setState({ text: '' });
    this.props.logClearFullTextSearch(this.refs.search.value);
  }

  render() {
    const { text } = this.state;
    return (
      <Fragment>
        <Title>Search</Title>
        <SearchBoxContainer>
          <SearchboxForm onSubmit={this.handleSubmit}>
            <SearchInput type="search" ref="search" placeholder="Search..." onChange={this.onChange} />
            <ActionContainer>
              <SearchButton
                type="submit"
                className={text ? 'tmt-mobile-hide' : ''}
              />
              <ResetButton
                type="reset"
                isHide={!text}
                className="tmt-mobile-show"
                onClick={this.clearInput}
              />
            </ActionContainer>
          </SearchboxForm>
        </SearchBoxContainer>
      </Fragment>
    );
  }
}
